import { Tooltip } from '@round/creatorbase-ui';
import styles from './TruncatedText.module.css';

type Props = {
    text: string;
    /** Makes the text a link to this url, opened in a new tab. */
    href?: string;
};

/** Text that runs long, truncated to its cell with the whole of it in a tooltip. */
const TruncatedText = ({ text, href }: Props) => (
    <Tooltip>
        <Tooltip.TriggerOnOverflow asChild>
            {href ? (
                <a href={href} target="_blank" rel="noopener noreferrer" className={styles.truncated}>
                    {text}
                </a>
            ) : (
                <span className={styles.truncated}>{text}</span>
            )}
        </Tooltip.TriggerOnOverflow>
        <Tooltip.Content className={styles.tooltip}>{text}</Tooltip.Content>
    </Tooltip>
);

export default TruncatedText;
